/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_On_Req1Inputs */

const en_wc_on_req1 = /** @type {(inputs: Wc_On_Req1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A recent Chrome, Edge, Firefox or Safari. WordCraft uses WebGPU and falls back to WebGL2 automatically.`)
};

/**
* | output |
* | --- |
* | "A recent Chrome, Edge, Firefox or Safari. WordCraft uses WebGPU and falls back to WebGL2 automatically." |
*
* @param {Wc_On_Req1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_on_req1 = /** @type {((inputs?: Wc_On_Req1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_On_Req1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_on_req1(inputs)
});
export { wc_on_req1 as "wc.on.req1" }